import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PreviousSelfieState, previousSelfieFeatureKey } from '../reducers/previous-selfie.reducer';
import * as fromEmployeeMainReducer from '../employee-detail.reducer';
import * as previousSelfieState from '../reducers/previous-selfie.reducer';

//#region Employee detail ROOT STATE
export const getMainEmployeeState = createFeatureSelector<fromEmployeeMainReducer.State, PreviousSelfieState>(
  fromEmployeeMainReducer.employeeDetailFeatureKey
);
//#endregion

//#region Employee previous Selfie SUB STATE
export const getPreviousSelfieState = createSelector(getMainEmployeeState, state => state[previousSelfieFeatureKey]);
//#endregion

//#region Employee Previous Selfie SUB STATE
export const getPreviousSelfieRequest = createSelector(getPreviousSelfieState, previousSelfieState.getPreviousSelfieRequest);
export const getPreviousSelfieSuccess = createSelector(getPreviousSelfieState, previousSelfieState.getPreviousSelfieResponse);
export const getPreviousSelfieFailure = createSelector(getPreviousSelfieState, previousSelfieState.getPreviousSelfieFailure);
//#endregion
